// OAuth Calendar: connecting to calendar page

/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

import ContentContainer from '../components/contentContainer';
import WidgetDialog from '../components/dialogs';
import TransitionAvatar from '../components/transitionAvatar';
import TitleHeader from '../components/titleHeader';
import TranslationIds from '../../commons/translationIds';
import CommonImages from '../../commons/images';
import { 
    getCalendarLogo,
    getCalendarName,
 } from '../../commons/utils/utils';

import useWidgetTheme from '../../commons/widgetTheme';
import useTranslator from '../../commons/translations';
import useUIStates from '../../store/models/uistates/useUIStates';
import { useAppStore } from '../../store/models/app';
import { useStyles } from './styles';

import usePageTransitions from '../../store/models/animations/usePageTransitions';
import { TransitionViewNames } from '../../store/models/animations/actions/transitions';
import useKickstarted from '../../commons/hooks/useKickstarted';

function OauthLauncher (props) {
    const {
        viewAnimation = false,
        initStyles = {},
    } = props;

    const  {
        translate,
        translateWithValues,
    } = useTranslator();

    const {
        selectedCalendar,
    } = useUIStates();

    const {
        widget,
        widgetTheme,
    }  = useWidgetTheme();

    const appStore = useAppStore();

    const classes = useStyles({
        widget,
        widgetTheme,
    });

    useKickstarted({
        onKickstarted: () => {},
    });
    

    usePageTransitions({
        elementName: TransitionViewNames.OAUTH_LAUNCHER_VIEW,
        viewAnimation,
    });

    if (!appStore.kickstarted) {
        return (<React.Fragment></React.Fragment>);
    }
    
    return (
        <React.Fragment>
            <ContentContainer>
                <WidgetDialog
                    isShowBackButton={false}
                    viewAnimation={viewAnimation}
                    initStyles={initStyles}
                    name={TransitionViewNames.OAUTH_LAUNCHER_VIEW}
                >
                     <Grid className={classes.content}>

                        <Grid className={classNames([classes.titleHeader])}>
                            <TitleHeader
                                widget={widget}
                                widgetTheme={widgetTheme}
                                title={translateWithValues(TranslationIds.USER_CONNECTING_TO_CALENDAR, { calendar: getCalendarName(selectedCalendar) })}
                            />
                        </Grid>

                        <TransitionAvatar
                            calendarLogoURL={getCalendarLogo(selectedCalendar)}
                            clientLogoURL={widget?.logo}
                            loadingIcon={CommonImages.LOADING_ANIMATION}
                        />

                        <Grid className={classNames([classes.oauthBeforeBody])}>
                            <Grid className={classNames([classes.bodyMessages])}>
                                <Typography variant={'body1'}>
                                    {translateWithValues(TranslationIds.USER_WAITING_FOR_CALENDAR, { calendar: getCalendarName(selectedCalendar) })}
                                </Typography>
                            </Grid>
                            <Grid className={classNames([classes.bodyMessages])}>
                                <Typography variant={'body1'}>
                                    {translate(TranslationIds.USER_PLEASE_LOGIN)}
                                </Typography>
                            </Grid>
                            <Grid className={classNames([classes.bodyMessages, classes.nothingHappenedMsg])}>
                                <Typography variant={'body1'}>
                                    {translate(TranslationIds.USER_NOTHING_HAPPENED)}&nbsp;
                                </Typography>

                                <Link
                                    className={classes.loginLink}
                                    onClick={() => {
                                        // note - only launch animation when about to launch and change the page...
                                        appStore.launchOauthPage();
                                    }}
                                >
                                    {translate(TranslationIds.USER_CLICK_HERE_TO_LOGIN)}
                                </Link>
                            </Grid>
                        </Grid>
                     </Grid>
                    
                </WidgetDialog>
            </ContentContainer>
        </React.Fragment>
    );
}

OauthLauncher.propTypes = {
    viewAnimation: PropTypes.bool,
    initStyles: PropTypes.any,
};

export default observer(OauthLauncher);
